(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("mobx"), require("sbRespLib"), require("mobxReact"));
	else if(typeof define === 'function' && define.amd)
		define("sb-responsive-pulse-bet-blocks", ["React", "mobx", "sbRespLib", "mobxReact"], factory);
	else if(typeof exports === 'object')
		exports["sb-responsive-pulse-bet-blocks"] = factory(require("React"), require("mobx"), require("sbRespLib"), require("mobxReact"));
	else
		root["sb-responsive-pulse-bet-blocks"] = factory(root["React"], root["mobx"], root["sbRespLib"], root["mobxReact"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_4__) {
return webpackJsonpsb_responsive_pulse_bet_blocks([1],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var sb_resp_lib_1 = __webpack_require__(2);
var dict_1 = __webpack_require__(145);
var config_1 = __webpack_require__(147);
var PulseBetMarkets_1 = __webpack_require__(149);
var data_1 = __webpack_require__(9);
var _;
var _localMock;
var PageMethodsOverridenMockedMethods;
var PageMethodsMock;
var MasterEventsPageMethodsMock;
var BettingHistoryPageMethodsMock;
var BettingPageMethodsMock;
var UserInfoMock;
var OddsMock;
var NavHandlerMock;
var BetSlipUtil;
if (false) {
    _ = require("sb-resp-lib/lib/mocks");
    _localMock = require("../../mocks");
    PageMethodsMock = _.PageMethodsMock;
    PageMethodsOverridenMockedMethods = _localMock.PageMethodsOverridenMockedMethods;
    UserInfoMock = _.UserInfoMock;
    MasterEventsPageMethodsMock = _localMock.MasterEventsPageMethodsMock;
    BettingHistoryPageMethodsMock = _localMock.BettingHistoryPageMethodsMock;
    BettingPageMethodsMock = _localMock.BettingPageMethodsMock;
    OddsMock = _.OddsMock;
    NavHandlerMock = _.NavHandlerMock;
    BetSlipUtil = _.BetSlipUtilMock;
}
var PulseBetMarketsRoot = /** @class */ (function (_super) {
    __extends(PulseBetMarketsRoot, _super);
    // constructor sets defaults
    function PulseBetMarketsRoot(domId, options) {
        if (options === void 0) { options = {
            dict: dict_1.BaseDict,
            cms: {},
            navHandler: {},
            dataProvider: {},
            betSlipUtil: {},
            oddsUtil: {},
            facade: {}
        }; }
        var _this = _super.call(this, domId, options) || this;
        if (false) {
            // setup data mocks for debug build
            _this.dataProvider = new data_1.PulseBetMarketsData({
                pageMethods: new PageMethodsMock(new PageMethodsOverridenMockedMethods()),
                masterEventsPageMethoods: new MasterEventsPageMethodsMock(),
                bettingHistoryPageMethods: new BettingHistoryPageMethodsMock(),
                bettingPageMethods: new BettingPageMethodsMock(),
                userInfo: UserInfoMock
            }, dict_1.BaseDict, config_1.config, new OddsMock(), new BetSlipUtil(), new NavHandlerMock());
            // setup dictionary for debug build
            _this.options.dict = dict_1.BaseDict;
            //export data store to window for debug purposes
            window["PulseBetMarketsDATA"] = _this.dataProvider;
        }
        // if no provided dictionary is not full fill in the missing keys with the base one
        _this.options.dict = __assign({}, dict_1.BaseDict, (options.dict || {}));
        // merge default and CMS options
        _this.options.cms = __assign({}, config_1.config, (options.cms || {}));
        if ("production" === "production" && typeof options.dataProvider !== "undefined") {
            // use pagemethods passed during the construction from the
            // mobile application
            _this.dataProvider = new data_1.PulseBetMarketsData(options.dataProvider, _this.options.dict, _this.options.cms, options.oddsUtil, options.betSlipUtil, options.navHandler);
        }
        return _this;
    }
    PulseBetMarketsRoot.prototype.activate = function () {
        return _super.prototype.activate.call(this, React.createElement(PulseBetMarkets_1.PulseBetMarkets, { dataProvider: this.dataProvider, dict: this.options.dict }));
    };
    return PulseBetMarketsRoot;
}(sb_resp_lib_1.BaseBlock));
exports.PulseBetMarketsRoot = PulseBetMarketsRoot;
window["PulseBetMarkets"] = PulseBetMarketsRoot;


/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(146));


/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseDict = {
    MyPulseBets: "My Pulse Bets",
    PlaceBet: "Place Pulse Bet",
    PleaseLoginToPlaceBet: "LOGIN TO BET",
    PulseBetInterval: "1 min Pulse",
    TimeIsSeconds: "Sec",
    ErrorMessage: "Error message",
    StartsLabel: "Starts In",
    GoLabel: "Go",
    GermanTaxesMessage: "In accordance with German tax law, {0} % tax will be deducted your total return.",
    BetWasAccepted: "Your bet was accepted",
    TicketLabel: "Ticket",
    GoToMyPulseBets: "Go to my pulse bets",
    Suspended: "Suspended",
    Sec: "Sec"
};


/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(148));


/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.config = {
    stakeSeries: [{
            defaultStake: 15,
            id: 3146,
            isDefault: true,
            pulseBettingStakeValuesSeries: [1, 5, 10, 15, 20, 50, 100]
        }, {
            defaultStake: 0,
            id: 3147,
            isDefault: false,
            pulseBettingStakeValuesSeries: [1, 2, 5, 7, 10, 25, 50]
        }, {
            defaultStake: 0,
            id: 3151,
            isDefault: false,
            pulseBettingStakeValuesSeries: [5, 10, 25, 50, 100, 200]
        }, {
            defaultStake: 2,
            id: 3312,
            isDefault: false,
            pulseBettingStakeValuesSeries: [1, 2, 3, 4, 5, 10, 25, 50, 100, 250, 500]
        }],
    stakeSeriesWithoutDefault: [{
            defaultStake: 15,
            id: 3146,
            isDefault: false,
            pulseBettingStakeValuesSeries: [1, 5, 10, 15, 20, 50, 100]
        }],
    autoCloseTimeout: 5000,
    preCountDownTimerInterval: 1000 // ms
};


/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var data_1 = __webpack_require__(9);
var SCMP = __webpack_require__(5);
var CMP = __webpack_require__(150);
var PulseBetMarkets = /** @class */ (function (_super) {
    __extends(PulseBetMarkets, _super);
    function PulseBetMarkets(props) {
        var _this = _super.call(this, props) || this;
        // setup dictionary
        _this.dict = _this.props.dict;
        _this.countDownValues = ["3", "2", "1", _this.props.dict.GoLabel];
        // setup data provider
        _this.state = {
            dataProvider: _this.props.dataProvider
        };
        return _this;
    }
    // A check needed to show which component should be rendered
    PulseBetMarkets.prototype.renderPulseBetContainer = function (pulseBetMarket) {
        var _this = this;
        return (React.createElement("div", { className: "rj-pulse-bet-market__collapsible-wrap", key: "" + pulseBetMarket.pulseBetMetadata.name },
            React.createElement(SCMP.InstantCollapsible, { trigger: React.createElement(SCMP.Heading, { label: pulseBetMarket.pulseBetMetadata.name }), content: React.createElement("div", { className: "rj-pulse-bet-market-main-container" }, this.state.dataProvider.eventsBetPlacementResult.map(function (data) {
                    return pulseBetMarket.pulseBetMetadata.marketId === data.eventId &&
                        _this.renderMarket(data, pulseBetMarket);
                })), initiallyExpanded: true })));
    };
    // TODO Add proper tests https://jira.sbtech.com/browse/SB-130238
    /* istanbul ignore next */
    PulseBetMarkets.prototype.renderPulseContent = function (pulseBetMarket, betPlacementData) {
        var _this = this;
        return (React.createElement("div", { className: "rj-pulse-bet-markets", "data-suspended": this.state.dataProvider.isDanger },
            React.createElement(SCMP.Winnings, { inputData: pulseBetMarket.winings, onStakeChangeFading: pulseBetMarket.onStakeChangeFading }),
            React.createElement(CMP.TimePeriod, { periodFrames: pulseBetMarket.periodFrames.map(function (period) { return period + " " + _this.state.dataProvider.addSuffix(pulseBetMarket.pulseBetMetadata.marketId); }) }),
            React.createElement("div", { className: "rj-pulse-bet-markets__pre-bet" },
                React.createElement(SCMP.SlimProgressbar, { eventID: pulseBetMarket.pulseBetMetadata.marketId })),
            React.createElement("div", { className: "rj-pulse-bet-markets__btns-holder" },
                React.createElement(CMP.StakeHolder, { data: this.state.dataProvider.stakeInputDataView(pulseBetMarket.pulseBetMetadata.marketId) }),
                React.createElement(SCMP.PulseBetButton, { handler: pulseBetMarket.externalPlaceBetHandler, isDisabled: this.state.dataProvider.isDanger }, this.state.dataProvider.placeButtonText)),
            React.createElement("div", { className: "rj-pulse-bet-markets__messages" },
                betPlacementData.status === data_1.BetPlacementStatus.Error && React.createElement(CMP.ErrorMessage, { error: betPlacementData.error }),
                this.state.dataProvider.isUserLogged &&
                    this.state.dataProvider.userInfo.TaxProvider && !!this.state.dataProvider.userInfo.TaxProvider.TaxInfo.CountryTax &&
                    React.createElement(CMP.GermanTaxesMessage, { text: this.props.dict.GermanTaxesMessage.format(this.state.dataProvider.userInfo.TaxProvider.TaxInfo.CountryTax) }))));
    };
    PulseBetMarkets.prototype.renderAcceptedBetMessage = function (betPlacementData) {
        return (React.createElement(CMP.AcceptedBet, { data: betPlacementData.success }));
    };
    PulseBetMarkets.prototype.renderMarket = function (betPlacementData, pulseBetMarket) {
        return (React.createElement(React.Fragment, { key: "" + pulseBetMarket.pulseBetMetadata.marketId }, this.renderPulseBetMarketView(pulseBetMarket, betPlacementData)));
    };
    PulseBetMarkets.prototype.renderPulseBetMarketView = function (pulseBetMarket, betPlacementData) {
        switch (betPlacementData.status) {
            case data_1.BetPlacementStatus.InProcess:
                return React.createElement(CMP.PulseLoading, null);
            case data_1.BetPlacementStatus.Success:
                return this.renderAcceptedBetMessage(betPlacementData);
            case data_1.BetPlacementStatus.Error:
            case data_1.BetPlacementStatus.NotStarted:
            default:
                return this.renderPulseContent(pulseBetMarket, betPlacementData);
        }
    };
    PulseBetMarkets.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null, this.state.dataProvider.store.pulsebetsDataForComponents.map(function (data) { return _this.renderPulseBetContainer(data); })));
    };
    PulseBetMarkets = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], PulseBetMarkets);
    return PulseBetMarkets;
}(React.Component));
exports.PulseBetMarkets = PulseBetMarkets;


/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(151));
__export(__webpack_require__(31));
__export(__webpack_require__(32));
__export(__webpack_require__(155));
__export(__webpack_require__(158));
__export(__webpack_require__(33));
__export(__webpack_require__(160));
__export(__webpack_require__(162));
__export(__webpack_require__(164));


/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(152));


/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var models_1 = __webpack_require__(3);
var StakeButton_1 = __webpack_require__(31);
var StakeValue_1 = __webpack_require__(32);
var StakeHolder = /** @class */ (function (_super) {
    __extends(StakeHolder, _super);
    function StakeHolder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StakeHolder.prototype.render = function () {
        var _this = this;
        var _a = this.props.data, stakeFormatted = _a.stakeFormatted, isMinusDisabled = _a.isMinusDisabled, isPlusDisabled = _a.isPlusDisabled;
        return (React.createElement("div", { className: "rj-my-pulse-bets__stake-holder" },
            React.createElement(StakeButton_1.StakeButton, { handler: function (e) { _this.props.data.stakeDown(_this.props.data.eventId); }, isActive: isMinusDisabled, modifier: models_1.StakeModifier.minus }),
            React.createElement(StakeValue_1.StakeValue, { stakeValue: stakeFormatted }),
            React.createElement(StakeButton_1.StakeButton, { handler: function (e) { _this.props.data.stakeUp(_this.props.data.eventId); }, isActive: isPlusDisabled, modifier: models_1.StakeModifier.plus })));
    };
    return StakeHolder;
}(React.Component));
exports.StakeHolder = StakeHolder;


/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var sb_resp_lib_1 = __webpack_require__(2);
var baseClass = "rj-my-pulse-bets__stake-btn";
//export enum Props { plus = "plus", minus = "minus" }
var StakeButton = /** @class */ (function (_super) {
    __extends(StakeButton, _super);
    function StakeButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StakeButton.prototype.render = function () {
        var _a = this.props, isActive = _a.isActive, modifier = _a.modifier, handler = _a.handler;
        var mdf = " " + baseClass + "--" + modifier;
        return (React.createElement("button", { disabled: isActive, className: "" + baseClass + mdf, onClick: handler },
            React.createElement(sb_resp_lib_1.Icon, { i: "i-14 i-o-pulse-" + modifier })));
    };
    return StakeButton;
}(React.Component));
exports.StakeButton = StakeButton;


/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var StakeValue = /** @class */ (function (_super) {
    __extends(StakeValue, _super);
    function StakeValue() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StakeValue.prototype.render = function () {
        return (React.createElement("div", { className: "rj-my-pulse-bets__stake-value" },
            React.createElement("span", null, this.props.stakeValue)));
    };
    return StakeValue;
}(React.Component));
exports.StakeValue = StakeValue;


/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(156));


/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var CloseButton_1 = __webpack_require__(33);
var ErrorMessage = /** @class */ (function (_super) {
    __extends(ErrorMessage, _super);
    function ErrorMessage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorMessage.prototype.render = function () {
        return (React.createElement("div", { className: "rj-pulse-bet-markets__error-message" },
            React.createElement("span", { className: "rj-pulse-bet-markets__error-message-text", dangerouslySetInnerHTML: { __html: this.props.error.message } }),
            React.createElement(CloseButton_1.CloseButton, { handler: this.props.error.handler })));
    };
    return ErrorMessage;
}(React.Component));
exports.ErrorMessage = ErrorMessage;


/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var sb_resp_lib_1 = __webpack_require__(2);
var CloseButton = /** @class */ (function (_super) {
    __extends(CloseButton, _super);
    function CloseButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CloseButton.prototype.render = function () {
        var handler = this.props.handler;
        return (React.createElement("button", { className: "rj-pulse-bet-markets__close-button", onClick: handler },
            React.createElement(sb_resp_lib_1.Icon, { i: "i-12 i-o-pulsebet-clear" })));
    };
    return CloseButton;
}(React.Component));
exports.CloseButton = CloseButton;


/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(159));


/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var PulseLoading = /** @class */ (function (_super) {
    __extends(PulseLoading, _super);
    function PulseLoading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PulseLoading.prototype.render = function () {
        return (React.createElement("div", { className: "rj-pulse-bet-markets__pulse-loading" }));
    };
    return PulseLoading;
}(React.Component));
exports.PulseLoading = PulseLoading;


/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(161));


/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var GermanTaxesMessage = /** @class */ (function (_super) {
    __extends(GermanTaxesMessage, _super);
    function GermanTaxesMessage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GermanTaxesMessage.prototype.render = function () {
        return (React.createElement("div", { className: "rj-pulse-bet-markets__german-taxes-message" },
            React.createElement("span", { className: "rj-pulse-bet-markets__german-taxes-message-text" }, this.props.text)));
    };
    return GermanTaxesMessage;
}(React.Component));
exports.GermanTaxesMessage = GermanTaxesMessage;


/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(163));


/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var PulseBetButton_1 = __webpack_require__(11);
var baseClass = "rj-pulse-bet-market__accepted-bet";
var AcceptedBet = /** @class */ (function (_super) {
    __extends(AcceptedBet, _super);
    function AcceptedBet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //currently for the handler it is unclear what it should do from bussiness side so for now we removing onClick
    AcceptedBet.prototype.render = function () {
        return (React.createElement("div", { className: baseClass + "-container", onClick: this.props.data.areaHandler },
            React.createElement("div", { className: baseClass + "-message" }, this.props.data.message),
            React.createElement("div", { className: baseClass + "-ticket-container" },
                React.createElement("span", { className: baseClass + "-interval" }, this.props.data.timeInterval),
                React.createElement("span", { className: baseClass + "-ticket" }, this.props.data.ticketLabel),
                React.createElement("span", { className: baseClass + "-number" }, this.props.data.ticketId)),
            React.createElement(PulseBetButton_1.PulseBetButton, { modifier: "accepted-bet", handler: this.props.data.handler }, this.props.data.buttonLabel)));
    };
    return AcceptedBet;
}(React.Component));
exports.AcceptedBet = AcceptedBet;


/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(165));


/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var baseClass = "rj-pulse-bet-markets__time-period";
var TimePeriod = /** @class */ (function (_super) {
    __extends(TimePeriod, _super);
    function TimePeriod() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimePeriod.prototype.renderPeriods = function () {
        return this.props.periodFrames.map(this.periodFrameDraw, this);
    };
    TimePeriod.prototype.periodFrameDraw = function (frame) {
        return (React.createElement("span", { className: baseClass + "-frame", key: frame }, frame));
    };
    TimePeriod.prototype.render = function () {
        return (React.createElement("div", { className: "" + baseClass }, this.renderPeriods()));
    };
    return TimePeriod;
}(React.Component));
exports.TimePeriod = TimePeriod;


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(153));


/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(154));


/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(157));


/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ })

},[144]);
});


// WEBPACK FOOTER //
// pulsebetmarkets.js